import React, { useEffect } from 'react';
import { Box, ScrollBox, Text } from '@ublend-npm/aulaui-core';
import CardView from './CardView';
import NoSpace from './NoSpace';

const RecentlyViewedSpaces = ({
  onfetchRecentlyViewedSpaces,
  recentlyViewedSpaceList,
  onSpaceStar,
  isStaff,
  isEducator,
}: any) => {
  useEffect(() => {
    onfetchRecentlyViewedSpaces();
  }, [onfetchRecentlyViewedSpaces]);

  const spaceList =
    recentlyViewedSpaceList?.map((spaces) => ({
      ...spaces,
      isEducator,
      isStaff,
    })) || [];

  const cardViewFn = (props) => {
    return (
      <Box key={props.spaceId}>
        <CardView
          {...props}
          onSpaceStar={onSpaceStar}
          onfetchRecentlyViewedSpaces={onfetchRecentlyViewedSpaces}
        />
      </Box>
    );
  };
  const Title = () => (
    <Text tabIndex={0} fontWeight={600} fontSize="1.25rem">
      {' '}
      Recently viewed{' '}
    </Text>
  );
  return spaceList?.length ? (
    <ScrollBox
      // @ts-expect-error
      title={<Title />}
      render={cardViewFn}
      dataSource={spaceList}
      hideScrollbar
      showArrows
    />
  ) : (
    <NoSpace />
  );
};

export { RecentlyViewedSpaces };
